import * as accountReports from '@shared/api/accountReports';

export const appApi = {
  accountReports
};
